// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2J14MD6mYDcRIVNdIue4X0{aspect-ratio:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageSkeleton": "_2J14MD6mYDcRIVNdIue4X0"
};
module.exports = ___CSS_LOADER_EXPORT___;
